import { ReactElement } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import LoginForm from '../../components/ClubeBaneficios/LoginForm';
import RegisterForm from '../../components/ClubeBaneficios/RegisterForm';

export default function Cadastro(): ReactElement {
  const location = useLocation();
  const navigate = useNavigate();

  const isRegister = location.pathname.endsWith('/registerForm');

  return (
    <div className="flex min-h-[100dvh] flex-col bg-gray-50 px-4 py-6 sm:px-6 sm:py-10">
      <section
        aria-label="Clube de Benefícios"
        className={`mx-auto w-full max-w-4xl overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm ${
          isRegister ? '' : 'my-auto'
        }`}
      >
        {isRegister ? (
          <>
            <header className="flex justify-center border-b border-gray-100 px-5 py-6 sm:px-8">
              <img
                src="/assets/logos/ClubBeneficios.png"
                alt="Cuidado - Clube de Benefícios"
                width={224}
                height={54}
                className="h-[54px] w-[224px] max-w-full object-contain"
              />
            </header>
            <div className="px-5 py-6 sm:p-8">
              <RegisterForm
                onSwitchToLogin={() => navigate('/ClubeBeneficios')}
              />
            </div>
          </>
        ) : (
          <div className="grid min-w-0 md:grid-cols-2">
            <aside
              aria-label="Boas-vindas ao clube"
              className="relative flex min-w-0 flex-col overflow-hidden border-b border-gray-200 bg-blue-50 text-center md:min-h-[384px] md:border-b-0 md:border-r"
            >
              <div
                className="h-14 w-full flex-shrink-0 overflow-hidden md:absolute md:inset-x-0 md:top-0 md:h-32"
                aria-hidden="true"
              >
                <svg
                  viewBox="0 0 1200 120"
                  preserveAspectRatio="none"
                  focusable="false"
                  className="h-full w-full rotate-180 fill-[#561b85]"
                >
                  <path d="M 0 40 C 60 60 180 90 300 80 C 480 65 720 10 900 25 C 1040 40 1140 80 1200 60 V 120 H 0 Z" />
                </svg>
              </div>
              <div className="flex min-w-0 flex-1 flex-col items-center justify-center gap-3 px-5 py-5 md:gap-6 md:px-8 md:py-10">
                <img
                  src="/assets/logos/ClubBeneficios.png"
                  alt="Cuidado - Clube de Benefícios"
                  width={262}
                  height={62}
                  className="h-[54px] w-[224px] max-w-full object-contain md:h-[62px] md:w-[262px]"
                />
                <p className="max-w-xs text-sm font-medium leading-relaxed text-gray-700 md:text-base">
                  Aproveite vantagens exclusivas para você!
                </p>
              </div>
            </aside>
            <div className="min-w-0 px-5 py-6 sm:p-8">
              <LoginForm
                onSwitchToRegister={() =>
                  navigate('/ClubeBeneficios/registerForm')
                }
              />
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
